import React from 'react';
import './About.css'

const About = () => {
    return (
        <div className="about-container">
            <div>
                <h2>THIS IS ALL ABOUT</h2>
                <p>First of all we most welcome you who visit our website.</p>
                <p>Our company host 1995 and our company website published on internet 2010. </p>
                <p>Successfully in over 120 countires our service done and 1.5M trips compeleted with yours support.</p>
            </div>
        </div>
    );
};

export default About;